import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fontsource/inter';
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material/styles';
import { brandPalette } from './brandPalette';
import { initMailRuPixel } from './utils/mailRuPixel';
import { registerAssetFallback } from './utils/registerAssetFallback';
import { captureSeoPrerender } from './components/base/AppLoadingFallback';
import RouteErrorBoundary from './components/base/PageErrorBoundary';

initMailRuPixel();

captureSeoPrerender();
const root = ReactDOM.createRoot(document.getElementById('root'));

const theme = createTheme({
  palette: brandPalette,
  typography: {
    fontFamily: '"Roboto", "Helvetica Neue", Arial, Helvetica, sans-serif',
  },
});

export default theme;


registerAssetFallback().then(() => root.render(

    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ThemeProvider theme={theme}>
        <RouteErrorBoundary><App /></RouteErrorBoundary>
      </ThemeProvider>
    </BrowserRouter>

));

reportWebVitals();
